import React, { useRef, useEffect, useImperativeHandle, useState } from 'react';
import styles from './styles.less';

const Player = React.forwardRef((props, ref) => {
  const playerContainerRef = useRef();
  // const [player, setPlayer] = useState(null);
  const playerObj = useRef(null);
  const {
    url,
    defaultMute,
    onStop = () => {},
    vloume,
    isResize = true,
  } = props;
  // const [played, setPlayed] = useState(false);
  const playedRef = useRef(false);
  const playedTimerRef = useRef();
  const onStatsCallback = useRef(() => {});
  const isPause = useRef(false);

  useImperativeHandle(ref, () => ({
   pause: () => {
      playerObj.current.pause();
    },
    play: (url) => {
      playerObj.current.play(url);
    },
    screenshot: () => {
      return playerObj.current.screenshot('flienamebysnap','jpeg', 1,'blob');
    },
    mute: () => {
      playerObj.current.mute();
    },
    cancelMute: () => {
      playerObj.current.cancelMute();
    },
    setRotate: (deg) => {
      playerObj.current.setRotate(deg);
    },
    resize: () => {
      playerObj.current.resize();
    },
  }));
  let timer;
  const creat = () => {
    const player = new window.JessibucaPro({
      container: playerContainerRef.current,
      decoder: `decoder-pro.js`,
      videoBuffer: 0.1,
      videoBufferDelay: 0,
      isNotMute: defaultMute === undefined ? true : !defaultMute,
      isResize,
      loadingText: '直播加载中，请稍等...',
      isFlv: true,
      useMSE: false,
      useSIMD: true,
      autoWasm: true, // 自动降级到 wasm 模式
      decoderErrorAutoWasm: false, // 解码失败自动降级到 wasm 模式
      //useCanvasRender: 'canvas',
      // debug: true,
      // debugLevel: 'debug',
      mseDecodeAudio: true,
      useVideoRender: true,
      useMThreading:true
    });

    playerObj.current = player;
    if (url) {
      player.play(url);

      player.on('play', () => {
        playedRef.current = true;
        isPause.current = false;
        clearTimeout(playedTimerRef.current);
      });

      player.on('error', () => {
        if (playedRef.current) {
          playedTimerRef.current = setTimeout(() => {
            onStop();
          }, 3000);
        }
        if (isPause.current) return;
        timer = setTimeout(() => {
          player.play(url);
        }, 1500);
      });

      // player.on('stats', onStatsCallback.current);
      // 流状态统计，流开始播放后回调，每秒1次。
      player.on('stats', function (s) {
        // console.log(s);
      });
    }
  };
  useEffect(() => {
    creat();
    const cleanupPlayer = () => {
      clearTimeout(timer);
      isPause.current = false;
      playedRef.current = false;
      if (playerObj.current) {
        playerObj.current.destroy();
      }
    };
    return () => {
      cleanupPlayer();
    };
  }, []);

  const updateLive = async () => {
    await playerObj.current.destroy();
    if (url) {
      creat();
    }
  };
  useEffect(() => {
    if (playerObj.current) {
      // updateLive();
      if(url){
        playerObj.current.play(url);
      }
      //设置过声音，手动触发一下
      if (!defaultMute) {
        setTimeout(() => {
          playerObj.current.cancelMute();
        }, 500);
      } else {
        setTimeout(() => {
          playerObj.current.mute();
        }, 500);
      }
    }
  }, [url]);
  return <div className={styles.playBox} ref={playerContainerRef}></div>;
});

export default Player;